import { apiUrl } from 'config';
import axios from '../_helpers/axios';

export const appService = {
  runApp,
  globalPatch,
};

function globalPatch() {
  Array.prototype.uniqueBy = function(prop) {
    return this.filter((v, i, a) => a.indexOf(a.find(e=>e[prop]===v[prop])) === i);
  };

  Array.prototype.remove = function() {
    var what,
      a = arguments,
      L = a.length,
      ax;
    while (L && this.length) {
      what = a[--L];
      while ((ax = this.indexOf(what)) !== -1) {
        this.splice(ax, 1);
      }
    }
    return this;
  };

  if (!('path' in Event.prototype)) {
    Object.defineProperty(Event.prototype, 'path', {
      get: function() {
        var path = [];
        var currentElem = this.target;
        while (currentElem) {
          path.push(currentElem);
          currentElem = currentElem.parentElement;
        }
        if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
          path.push(document);
        if (path.indexOf(window) === -1) path.push(window);
        return path;
      },
    });
  }
}

async function runApp() {
  await axios
    .get(`${apiUrl}/api/runApp`)
    .then(r => {
      if (!r.success) {
        console.log(r.error);
        location.reload(true);
        throw r.error;
      }
    })
    .catch(error => {
      console.log(error);
      throw error;
    });

  return await axios
    .get(`${apiUrl}/api/getRights`)
    .catch(error => {
      console.error(error);
      throw error;
    });
}
